import React from 'react';
import { Users, Award, Gift, ArrowRight } from 'lucide-react';
import { StatCard, ReferralBox } from './components/SponsorshipComponents';
import { SponsorshipStats } from './types';

interface SponsorshipProps {
  stats: SponsorshipStats | null;
  copied: boolean;
  onCopy: () => void;
  onWhatsApp: () => void;
  onLinkedIn: () => void;
  onEmail: () => void;
}

export const MobileSponsorship: React.FC<SponsorshipProps> = ({ 
  stats, 
  copied, 
  onCopy, 
  onWhatsApp, 
  onLinkedIn,
  onEmail
}) => {
  console.log('[MobileSponsorship] Render method called. Stats:', stats);

  return (
    <div className="sponsorship-container mobile-view">
      {/* 1. Impactful Value Prop */}
      <div className="mobile-header">
        <div className="mini-badge">
          <Gift size={16} />
          <span>PRO OFFERT</span>
        </div>
        <h1>Offrez 15j, Gagnez 1 mois</h1>
      </div>

      {/* 2. Critical Stats - Stacked & Compact */}
      <div className="mobile-stats-grid">
        <StatCard 
          variant="highlight"
          label="Récompenses cumulées"
          value={stats?.pro_days_earned || 0}
          subValue="jours"
          isMobile={true}
          isZeroState={!stats?.pro_days_earned || stats.pro_days_earned === 0}
        />
        <div className="secondary-stats">
          <StatCard 
            icon={<Users size={20} className="text-blue" />} 
            label="Amis" 
            value={stats?.total_referrals || 0} 
            isMobile={true}
          />
          <StatCard 
            icon={<Award size={20} className="text-green" />} 
            label="Validés" 
            value={stats?.validated_referrals || 0} 
            isMobile={true}
          />
        </div>
      </div>

      {/* 3. Action Hub - Primary thumb reach area */}
      <div className="mobile-action-hub">
        <ReferralBox 
          shareLink={stats?.share_link} 
          referralCode={stats?.referral_code}
          isMobile={true}
          copied={copied}
          onCopy={onCopy}
          onWhatsApp={onWhatsApp}
          onLinkedIn={onLinkedIn}
          onEmail={onEmail}
        />
      </div>

      {/* 4. Progressive Disclosure: How it works */}
      <div className="mobile-steps-section">
        <h3>Comment ça marche ?</h3>
        <div className="vertical-timeline">
          <div className="timeline-item">
            <div className="timeline-dot">1</div>
            <div className="timeline-content">
              <h4>Partagez votre lien</h4>
              <p>Envoyez votre code unique à vos contacts investisseurs.</p>
            </div>
          </div>
          <div className="timeline-item">
            <div className="timeline-dot">2</div>
            <div className="timeline-content">
              <h4>15 jours offerts</h4>
              <p>Vos amis reçoivent un accès Pro gratuit pour découvrir Kaneabourse.</p>
            </div>
          </div>
          <div className="timeline-item">
            <div className="timeline-dot">3</div>
            <div className="timeline-content">
              <h4>Gagnez 1 mois</h4>
              <p>Dès qu'un ami s'abonne, vous gagnez immédiatement 1 mois d'abonnement Pro.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer CTA for clarification */}
      <div className="mobile-footer-info">
        <p>Plus vous partagez, plus vous restez Pro gratuitement.</p>
      </div>
    </div>
  );
};
